var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.prep_time !== '')?_c('div',{staticClass:"card mb-3"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title"},[_vm._v("Prep Time")]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("\n            "+_vm._s(_vm.prep_time)+"\n        ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }